import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from 'axios';
import { keys } from '../utils/utils';
var CLIENT_API_R0 = '/_matrix/client/r0';
/**
 * Handling the HTTP connection to the matrix synapse node
 */

export var MatrixHttpClient = /*#__PURE__*/function () {
  function MatrixHttpClient(baseUrl) {
    _classCallCheck(this, MatrixHttpClient);

    this.baseUrl = baseUrl;
    this.cancelTokenSource = axios.CancelToken.source();
  }
  /**
   * Get data from the synapse node
   *
   * @param endpoint
   * @param options
   */


  _createClass(MatrixHttpClient, [{
    key: "get",
    value: function get(endpoint, params, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.send('GET', endpoint, options, params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Post data to the synapse node
     *
     * @param endpoint
     * @param body
     * @param options
     * @param params
     */

  }, {
    key: "post",
    value: function post(endpoint, body, options, params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.send('POST', endpoint, options, params, body));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Put data to the synapse node
     *
     * @param endpoint
     * @param body
     * @param options
     * @param params
     */

  }, {
    key: "put",
    value: function put(endpoint, body, options, params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.send('PUT', endpoint, options, params, body));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.cancelTokenSource.cancel('Manually cancelled'));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Send a request to the synapse node
     *
     * @param method
     * @param endpoint
     * @param config
     * @param requestParams
     * @param data
     */

  }, {
    key: "send",
    value: function send(method, endpoint, config, requestParams, data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var headers, params, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                headers = config ? this.getHeaders(config) : undefined;
                params = requestParams ? this.getParams(requestParams) : undefined;
                _context5.prev = 2;
                _context5.next = 5;
                return axios.request({
                  method: method,
                  url: endpoint,
                  baseURL: this.apiUrl(CLIENT_API_R0),
                  headers: headers,
                  data: data,
                  params: params,
                  cancelToken: this.cancelTokenSource.token
                });

              case 5:
                response = _context5.sent;
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
                throw _context5.t0.response.data;

              case 11:
                return _context5.abrupt("return", response.data);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 8]]);
      }));
    }
    /**
     * Get the headers based on the options object
     *
     * @param options
     */

  }, {
    key: "getHeaders",
    value: function getHeaders(options) {
      var headers = {};
      var entries = [];

      if (options.accessToken) {
        entries.push(['Authorization', "Bearer ".concat(options.accessToken)]);
      }

      if (entries.length === 0) {
        return undefined;
      }

      for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
        var _entries$_i = _slicedToArray(_entries[_i], 2),
            key = _entries$_i[0],
            value = _entries$_i[1];

        headers[key] = value;
      }

      return headers;
    }
    /**
     * Get parameters
     *
     * @param _params
     */

  }, {
    key: "getParams",
    value: function getParams(_params) {
      if (!_params) {
        return undefined;
      }

      var params = Object.assign(_params, {});
      keys(params).forEach(function (key) {
        return params[key] === undefined && delete params[key];
      });
      return params;
    }
    /**
     * Construct API URL
     */

  }, {
    key: "apiUrl",
    value: function apiUrl() {
      var apiBase = this.baseUrl.endsWith('/') ? this.baseUrl.substr(0, this.baseUrl.length - 1) : this.baseUrl;

      for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
        parts[_key] = arguments[_key];
      }

      var apiParts = parts.map(function (path) {
        return path.startsWith('/') ? path.substr(1) : path;
      });
      return [apiBase].concat(_toConsumableArray(apiParts)).join('/');
    }
  }]);

  return MatrixHttpClient;
}();